import React from "react";
import { ColumnValueRendererProps } from "../table.data.interface";
import { Tooltip } from "@vibe/core";
import { sanitizeUrl } from "../../../utils/security/sanitizeUrl";

interface MondayDocFile {
  name: string;
  url: string;
  assetId: number;
  linkToFile?: string;
  fileId: string;
}

const MondayDocColumn = ({
  columnData,
  itemIds,
  isPreview,
  otherBoardsValues,
}: ColumnValueRendererProps) => {
  if (
    columnData.value === "Empty Column" ||
    (!columnData.value && isPreview) ||
    (!columnData.value && otherBoardsValues)
  ) {
    return null;
  }

  // Parse the value to get file information
  let files: MondayDocFile[] = [];
  if (columnData.value) {
    try {
      const valueString =
        typeof columnData.value === "string" ? columnData.value : JSON.stringify(columnData.value);
      const parsedValue = JSON.parse(valueString);
      files = parsedValue.files || [];
    } catch (error) {
      console.error("Error parsing monday doc column value:", error);
      return null;
    }
  }

  if (files.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 items-center">
      {files.map((file, index) => (
        <Tooltip key={index + 1} content={file.name}>
          <a
            href={sanitizeUrl(otherBoardsValues ? file?.linkToFile : file?.url)}
            target="_blank"
            rel="noopener noreferrer"
            className="flex gap-1 items-center text-blue-600 transition-colors hover:text-blue-800"
          >
            <img
              src="/img/monday-doc-icon_v2.svg"
              alt={file.name}
              className="flex-shrink-0 w-5 h-5"
            />
          </a>
        </Tooltip>
      ))}
    </div>
  );
};

export default MondayDocColumn;
